import autobind from 'autobind-decorator';
import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { getHotContests } from '~/api/oj/home';
import { RouterService } from '~/services/router.service';
import { showErrorMsg, showSuccessMsg } from '~/utils/utility';
import type { ContestVO } from '~/types/auto/oj';

@Injectable()
export class HotContestsService {
  public loading = false;
  public hotContests = [] as ContestVO[];

  @Inject(forwardRef(() => RouterService))
  public routerService!: RouterService;

  init() {
    this.getHotContests();
  }

  async getHotContests() {
    this.loading = true;
    getHotContests()
      .then((res) => {
        this.hotContests = res;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
